/**
 * Rodapé das páginas públicas (§21.12).
 *
 * Existe para que as páginas públicas se ALCANCEM: uma declaração de
 * acessibilidade que só quem sabe o endereço encontra não serve a ninguém. É
 * também o caminho para os documentos legais de quem ainda não tem conta.
 */

import { Link } from 'react-router-dom';
import { BRANDING } from '../config/branding';

const LINKS = [
  { to: '/sobre', rotulo: 'O produto' },
  { to: '/status', rotulo: 'Status' },
  { to: '/acessibilidade', rotulo: 'Acessibilidade' },
  { to: '/privacidade', rotulo: 'Privacidade' },
  { to: '/legal', rotulo: 'Documentos legais' },
  { to: '/contato', rotulo: 'Contato' },
  { to: '/entrar', rotulo: 'Entrar' },
];

export function RodapePublico(): JSX.Element {
  return (
    <footer className="mt-10 border-t border-line pt-4">
      <nav aria-label="Páginas públicas">
        <ul className="flex flex-wrap gap-x-4 gap-y-1">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="text-2xs text-ink-muted underline">
                {l.rotulo}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <p className="mt-3 text-2xs text-ink-subtle">{BRANDING.legalLine}</p>
    </footer>
  );
}
